module.exports = __webpack_public_path__ + "static/media/CircularStd-BlackItalic.02ae5721.ttf";